/**
 * Shared constants and value mappings for merchandiser lists (PD-13923).
 * Status values mirror the merchandiser entity enum (active/inactive/
 * maintenance/offline).
 */
export const MERCHANDISER_STATUS_VALUE_MAPPING = [
	{
		value: 'active',
		label: 'Active',
		color: { bg: '#dcfce7', text: '#166534' },
	},
	{
		value: 'inactive',
		label: 'Inactive',
		color: { bg: '#f3f4f6', text: '#6b7280' },
	},
	{
		value: 'maintenance',
		label: 'Maintenance',
		color: { bg: '#fef3c7', text: '#92400e' },
	},
	{
		value: 'offline',
		label: 'Offline',
		color: { bg: '#fee2e2', text: '#991b1b' },
	},
];
